package com.essntl.features.task.domain.repository

import com.essntl.features.task.domain.model.TaskFilterOptions
import com.essntl.features.task.domain.model.TaskModel

interface TaskRepository {
    suspend fun getById(id: String): Result<TaskModel>

    suspend fun getAllByItineraryServiceIds(itineraryServiceIds: List<String>): Result<List<TaskModel>>

    suspend fun getAllByItineraryId(itineraryId: String): Result<List<TaskModel>>
    suspend fun getAllByProposalId(proposalId: String): Result<List<TaskModel>>
    suspend fun getOverdueTasks(): Result<List<TaskModel>>
    suspend fun getAll(
        page: Long,
        limit: Int = 20,
        filterOptions: TaskFilterOptions,
    ): Result<List<TaskModel>>

    suspend fun getAllTodayTodoTasks(dueDate: String): Result<List<TaskModel>>

    suspend fun insert(task: TaskModel): Result<TaskModel>

    suspend fun update(task: TaskModel): Result<TaskModel>

    suspend fun delete(id: String): Result<Unit>
}
